// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";

// Util
import { vuelidateUtil } from "@/utils/vuelidate-util.js";

// Third Party libraries
import * as $ from "jquery";

// Services
import SubscriptionService from "@/app/services/main/subscription/subscription-service";

// Constants
import { STATUS_CODES, SUBSCRIPTION_STATUS } from "@/app/constants/constants";

export default {
    name: "ModalDisapproveSubscriptionCancellationRequest",
    mixins: [toastMessageMixins],
    data() {
        return {
            disapproveText: "",
            isAPILoading: false,
            subscriptionDetails: null,
        };
    },
    computed: {
        validationRules() {
            let field = {
                disapproveText: {},
            };

            field = vuelidateUtil.setRequiredValidation(
                field,
                "disapproveText"
            );

            return field;
        },
    },
    mounted() {
        $(this.$refs.modalDisapproveRequest).on(
            "hide.bs.modal",
            this.handleHideEvent
        );
    },
    beforeDestroy() {
        this.closeModal();
        $(this.$refs.modalDisapproveRequest).off(
            "hide.bs.modal",
            this.handleHideEvent
        );
    },
    methods: {
        openModal(subscriptionDetails) {
            this.resetFields();
            this.subscriptionDetails = subscriptionDetails;
            $(this.$refs.modalDisapproveRequest).modal("show");
        },
        closeModal() {
            this.$emit("onCloseModal");
            $(this.$refs.modalDisapproveRequest).modal("hide");
        },
        resetFields() {
            this.disapproveText = "";
            this.subscriptionDetails = null;
            this.$v.$reset();
        },
        handleHideEvent() {
            this.$emit("returnToOrderDetails", this.subscriptionDetails.id);
        },
        async submitDisapprove() {
            if (this.$v.$invalid) {
                return;
            }

            const { SUCCESS_CANCEL_SUBSCRIPTION, ERROR_CANCEL_SUBSCRIPTION } =
                this.toastMessages.subscription();

            try {
                const { id: subscriptionId } = this.subscriptionDetails;

                this.isAPILoading = true;

                const updateDetails = {
                    status: SUBSCRIPTION_STATUS.DISAPPROVED_CANCELLATION,
                    remarks: this.disapproveText,
                }

                const response = await SubscriptionService.updateSubscriptionStatusById(
                    subscriptionId,
                    updateDetails
                );

                if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                    this.showCustomSuccessToast(SUCCESS_CANCEL_SUBSCRIPTION);
                    this.closeModal();
                    this.orderActioned();
                } else {
                    this.showAPIErrorToast(ERROR_CANCEL_SUBSCRIPTION, response);
                }
                this.isAPILoading = false;
            } catch (error) {
                this.showGenericErrorToast();
                this.isAPILoading = false;
            }
        },
        orderActioned() {
			// will fire a refresh to fetch updated content 
            this.$emit("refreshContent");
        },
    },
    validations() {
        return this.validationRules;
    },
};
